import { jsx } from "react/jsx-runtime";
import { Stack } from "../Stack/Stack.mjs";
import { Shape } from "./Shape.mjs";
const Text = ({ lineCount = 1 }) => {
  const lines = new Array(lineCount).fill("");
  return /* @__PURE__ */ jsx(Stack, { space: "xsmall", children: lines.map((_, index) => /* @__PURE__ */ jsx(
    Shape,
    {
      height: "24px",
      width: index < lineCount - 1 || lineCount === 1 ? "`100%`" : "60%"
    },
    `text-skeleton-${index}`
  )) });
};
export {
  Text
};
